let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gdJBq")).then(() => parcelRequire('48H1x'));